import { render, staticRenderFns } from "./billRecordDialog.vue?vue&type=template&id=72674753&scoped=true&"
import script from "./billRecordDialog.vue?vue&type=script&lang=js&"
export * from "./billRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./billRecordDialog.vue?vue&type=style&index=0&id=72674753&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72674753",
  null
  
)

export default component.exports